import { useState } from 'react';
import { Box, Grid } from 'theme-ui';
import SimpleBar from 'simplebar-react';
import { getCurrencySymbol } from '@picsart/monetization/currencyService';
import { Title } from './oneTimePaymentAccordion/Title';
import { ContentItem } from './oneTimePaymentAccordion/ContentItem';
import { PremiumItemSource } from '../../constants';
import { PaidFeatures } from 'types/AppState';

export const currencySymbol = getCurrencySymbol();

export interface CombinedData extends PremiumData {
  count: number;
  price: number;
}

export interface PremiumData {
  type: PaidFeatures;
  id: string;
  src?: string;
  source: PremiumItemSource;
}

type OneTimePayAccordionBaseProps = {
  totalCount: number;
  totalAmount: number;
  combinedData: CombinedData[];
};

export const OneTimePayAccordion = ({
  totalCount,
  totalAmount,
  combinedData
}: OneTimePayAccordionBaseProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box sx={{ width: '100%', mt: 5 }}>
      <Title
        handleClick={() => setIsOpen(o => !o)}
        isOpen={isOpen}
        totalCount={totalCount}
        totalAmount={totalAmount}
      />
      {isOpen && (
        <SimpleBar autoHide={false} forceVisible="y" style={{ maxHeight: 88 }}>
          <Grid gap={3} columns={[1]}>
            {combinedData.map((item, i) => (
              <ContentItem key={i} {...item} />
            ))}
          </Grid>
        </SimpleBar>
      )}
    </Box>
  );
};
